define('view/disclosure/disclosure.send.adhoc.view',['require','exports','module','uikit/uikit','blockit','templates','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var UIKit                               = require('uikit/uikit'),
      BlocKit                             = require('blockit'),
      Templates                           = require('templates'),
      Radio                               = require('backbone.radio');

  var AdhocResultView = UIKit.SearchResults.Result.extend({
    template: Templates.App['adhoc.team.finder.results'],

    options: _.extend({}, UIKit.SearchResults.Result.prototype.options, {
      fullName: '',
      unitPersonList: '',
    }),
  });

  var AdHocSearchResults = UIKit.SearchResults.extend({
    childView: AdhocResultView,
  });

  var DisclosureSendAdHocView = BlocKit.ResolveOptionsView.extend({
    resolveOptions: {
      root: {
        type: BlocKit.FullWidthLayoutView,
        openTabIndex: 0,

        pageHeader: {
          breadcrumbs: [
            {
              text: 'Campaigns / Ad Hoc  Disclosures',
            },
          ],
          className: 'simplyTransparent',
        },

        contentColumn: {
          components: [
            {
              type: BlocKit.TabsContainerView,
              className: 'adHocActions',
              components: [
                {
                  tabMenuItem: {
                    text: 'Send Disclosure',
                    name: 'sendDisclosure',
                    horizontalNavMode: true,
                  },

                  tabContent: {
                    type: BlocKit.AttachedComponentsContainerView,

                    components: [
                      {
                        type: UIKit.Text,
                        renderAsHtml: true,
                        text:
                          'Ad hoc disclosures are a one-time email notification alerting them to submit their COI disclosure. If the desired user can not be found via search, check the </br>Admin settings and make sure that they are assigned the role COI Disclosee.',
                      },
                      {
                        type: UIKit.Header,
                        text: 'Select Disclosees to Notify',
                      },

                      {
                        type: BlocKit.TypeAheadFinderView,
                        model: '@resources.adHocDiscloseeModel',
                        placeholder: 'Search for disclosee by last name...',
                        adHocMemberFinderSelectedCollection: '@resources.adHocMemberFinderSelectedCollection',
                        queryFields: ['lastName'],
                        wildcardPrefix: '',
                        autocompleteDropdownBindings: {
                          fullName: 'fullName',
                          unitPersonList: 'unitPersonList',
                        },
                        autocompleteCollection: '@resources.adHocDiscloseeCollection',
                        searchResultsView: AdHocSearchResults,
                        onResultSelected: function(resultView, searchBehavior) {
                          searchBehavior.view.adHocMemberFinderSelectedCollection.add(resultView.model);
                        },
                        additionalBehaviors: {
                          resetInputValue: {
                            behaviorClass: Mn.Behavior.extend({
                              onFirstBeforeRender: function() {
                                this.listenTo(this.view, 'typeahead:item:selected', function(inputView) {
                                  inputView.value = '';
                                });
                              },
                            }),
                          },
                        },
                      },

                      {
                        type: UIKit.Table.extend({
                          className: (UIKit.Table.prototype.className += ' adHocteamselectedmembers'),
                        }),
                        borderless: true,
                        collection: '@resources.adHocMemberFinderSelectedCollection',
                        behaviors: {
                          whatsThatEvent: {
                            behaviorClass: Mn.Behavior.extend({
                              onFirstBeforeRender: function() {
                                this.listenTo(this.view, 'add:child', function() {
                                  var selectedCollection = this.view.collection;
                                  selectedCollection.add(this.model);
                                  this.view.trigger('change:disabled');
                                });
                              },
                            }),
                          },
                        },
                        columns: [
                          {
                            width: '25%',
                            text: 'Full Name',
                            data: 'fullName',
                          },
                          {
                            text: 'Units',
                            data: 'unitName',
                            className: 'unitColumn',
                          },
                          {
                            className: 'adHocClose',
                            childView: UIKit.Button.extend({
                              className: UIKit.Button.prototype.className + ' minimal',
                            }),
                            childViewOptions: {
                              color: 'red',
                              icon: 'x',
                              behaviors: {
                                setARIALabel: {
                                  behaviorClass: BlocKit.SetARIAAttributesBehavior,
                                  ariaItems: {
                                    label: function() {
                                      return 'Remove ' + this.view.model.get('fullName') + ' from this team.';
                                    },
                                  },
                                },
                                removeMemberFromTeam: {
                                  behaviorClass: Mn.Behavior.extend({
                                    onFirstBeforeRender: function() {
                                      this.view.on('press', function() {
                                        var selectedCollection = this.model.collection;

                                        selectedCollection.remove(this.model);
                                      });
                                    },
                                  }),
                                },
                              },
                            },
                          },
                        ],
                      },
                      {
                        type: UIKit.ComponentsContainerView,
                        className: 'actions',
                        id: 'actions',

                        components: [
                          {
                            type: UIKit.Message,
                            id: 'toast',
                            text: '',
                            format: '',
                            dismissable: true,
                            behaviors: {
                              setMessageState: {
                                model: '@resources.uiState',
                                optionValues: {
                                  format: {
                                    formatter: function(model) {
                                      return model.get('emailActionSuccess') ? 'positive' : 'negative';
                                    },
                                  },
                                  text: {
                                    formatter: function(model) {
                                      var successMessage = 'Notification successfully sent!';
                                      var failureMessage =
                                        'There was an error attempting to send the email. if this problem persists please contact  <a href="https://support:cayuse.com/">Cayuse Support</a> for assistance.';

                                      return model.get('emailActionSuccess') ? successMessage : failureMessage;
                                    },
                                  },
                                },
                                behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                              },

                              whatsThatEvent: {
                                behaviorClass: Mn.Behavior.extend({
                                  onFirstBeforeRender: function() {
                                    this.listenTo(this.view, 'change:visible', function() {
                                      if (arguments[1] === false) {
                                        // TODO: refactor later
                                        var uiStateResource = Radio.channel('AppKit.resourceService').request(
                                          'resource',
                                          'uiState'
                                        );

                                        uiStateResource.set({
                                          emailActionSuccess: false,
                                          emailActionNotify: false,
                                        });
                                      }
                                    });
                                  },
                                }),
                              },

                              BindAndFormatOptionValuesBehavior: {
                                optionValues: {
                                  visible: {
                                    model: '@resources.uiState',
                                    attribute: 'emailActionNotify',
                                    eventName: 'change',
                                    formatter: function(attribute) {
                                      return attribute;
                                    },
                                  },
                                },
                                behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                              },
                            },
                          },

                          {
                            type: UIKit.Button,
                            color: 'primary',
                            text: 'Send Notification',
                            uiState: '@resources.uiState',
                            discloseeCollection: '@resources.adHocMemberFinderSelectedCollection',

                            behaviors: {
                              BindAndFormatOptionValuesBehavior: {
                                optionValues: {
                                  disabled: {
                                    model: '@resources.adHocMemberFinderSelectedCollection',
                                    formatter: function(model) {
                                      return model.length === 0;
                                    },
                                  },
                                },
                                behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                              },

                              InvokeMethodOnEventBehavior: {
                                behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
                                eventName: 'press',
                                method: function() {
                                  var view = this.view;

                                  if (view.stopPropagation) {
                                    return;
                                  }

                                  view.loading = false;
                                  view.disabled = true;

                                  var selectedCollection = view.discloseeCollection;
                                  selectedCollection.save();
                                  selectedCollection.reset();

                                  var uiStateResource = Radio.channel('AppKit.resourceService').request(
                                    'resource',
                                    'uiState'
                                  );

                                  try {
                                    uiStateResource.set({
                                      emailActionSuccess: true,
                                      emailActionNotify: true,
                                    });
                                  } catch (error) {
                                    console.log(error);
                                  }
                                },
                              },
                            },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      },
    },
  });

  module.exports = DisclosureSendAdHocView;
});

